import Vue from 'vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

Vue.component('product-recently-viewed', {
  name: 'productRecentlyViewed',
  props: ['items'],
  data () {
    return {
      activeIndex: 0,
      swiperOption: {
        centeredSlides: false,
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchOverflow: true,
        navigation: {
          nextEl: '.product-recently-viewed__arrow.next',
          prevEl: '.product-recently-viewed__arrow.prev'
        },
        watchSlidesVisibility: true
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    resizeHandler (event) {
      this.$refs.swiperRefDesktop.swiper.slideTo(this.activeIndex)
    }
  },
  created () {
    this.innerWidth = window.innerWidth
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.resizeHandler)
  }
})
